import { apiSlice } from '../../api/apiSlice';

export const activitySearchApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    searchCastleVocabularies: builder.mutation({
      query: (option) => ({
        url: 'VocabularySearch/SearchCastleVocabularies',
        method: 'POST',
        body: option
      })
    }),
    getActivityCourseLevels: builder.mutation({
      query: (params) => ({
        url: `Level/ForActivity?${params}`,
        method: 'GET',
      })
    }),
    getActivityTopicsByLevel: builder.mutation({
      query: (options) => ({
        url: `Topic/${options.courseId}/VocabularyTopicsTree`,
        method: 'POST',
        body: options.levelIds
      })
    }),
    getVocabularyById: builder.mutation({
      query: ({ vocabularyId, pageSize }) => ({
        url: `VocabularySearch/GoToCastleVocabulary/${vocabularyId}/${pageSize}`,
        method: 'GET'
      })
    }),
    filterVocabularies: builder.mutation({
      query: (options) => ({
        url: 'VocabularySearch/FilterVocabularies',
        method: 'POST',
        body: options
      })
    }),
    selectRandomVocabularies: builder.mutation({
      query: (options) => ({
        url: 'VocabularySearch/SelectRandomVocabularies',
        method: 'POST',
        body: options
      })
    }),
    AddVocabularies: builder.mutation({
      query: (options) => ({
        url: `FlashCard/${options.id}/AddVocabularies`,
        method: 'POST',
        body: options.vocabularies
      }),
      extraOptions: { showGlobalError: true }
    }),
    searchExamVocabularies: builder.mutation({
      query: (options) => ({
        url: 'VocabularySearch/ExamVocabularies',
        method: 'POST',
        body: options
      }),
      extraOptions: { showGlobalError: true }
    }),
    getAllFlashcards: builder.mutation({
      query: (options) => ({
        url: `Flashcard/Course/${options.courseId}/Folder/${options.folderId}/${options.skip}/${options.take}?${options.params}`,
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    getFlashcardVocabularies: builder.mutation({
      query: (options) => ({
        url: `VocabularySearch/flashcard-vocabularies/${options.assignmentId}`,
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    getPublicFlashcardVocabularies: builder.mutation({
      query: (options) => ({
        url: `VocabularySearch/public/flashcard-vocabularies/${options.assignmentId}`,
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    searchByVocabularyId: builder.mutation({
      query: (options) => ({
        url: 'VocabularySearch/ByVocabularyId',
        method: 'POST',
        body: options
      }),
      extraOptions: { showGlobalError: true }
    }),
    getPersonalContentSets: builder.mutation({
      query: (options) => ({
        url: `QSet/${options.skip}/${options.take}/QSetFlashcard`,
        method: 'GET'
      }),
      extraOptions: { showGlobalError: true }
    }),
    getVocabulariesByPersonalContentSet: builder.mutation({
      query: (searchRequest) => ({
        url: 'VocabularySearch/TeacherVocabularies',
        body: searchRequest,
        method: 'POST'
      })
    }),
  })
});

export const {
  useSearchCastleVocabulariesMutation,
  useGetActivityCourseLevelsMutation,
  useGetActivityTopicsByLevelMutation,
  useGetVocabularyByIdMutation,
  useSelectRandomVocabulariesMutation,
  useFilterVocabulariesMutation,
  useAddVocabulariesMutation,
  useSearchExamVocabulariesMutation,
  useGetAllFlashcardsMutation,
  useGetFlashcardVocabulariesMutation,
  useGetPublicFlashcardVocabulariesMutation,
  useSearchByVocabularyIdMutation,
  useGetPersonalContentSetsMutation,
  useGetVocabulariesByPersonalContentSetMutation
} = activitySearchApi;